import { createRequest } from 'redux-gateway'
import moment from 'moment'
import t from './actionTypes'
import { GET_LOCATIONS_ROUTE } from './constants'

export const loadLocations = (locations) => ({
  type: t.LOAD_LOCATIONS,
  payload: locations,
})

export const getLocations = (postalCode) => (dispatch) =>
  dispatch(
    createRequest({
      route: GET_LOCATIONS_ROUTE,
      params: {
        year: moment(new Date()).year(),
        zipCode: postalCode,
      },
    })
  ).then(
    (data) => dispatch(loadLocations(data)).payload,
    () => {
      throw new Error('Error getting updated county/state locations')
    }
  )
